import { useEffect, useState } from "react"
import Button from '@mui/material/Button';
import NoDataImg from '../../../assets/img/no-data.gif'
import { useLocation, useNavigate, useParams } from "react-router-dom"
import NavBar from "../../structure/NavBar"
import ReplyIcon from '@mui/icons-material/Reply'
import { NavBarTop } from "../../structure/NavBarTop"
import { updateTopHeader, uplodateLoading } from "../../../redux/features/common/commonSlice"
import { useDispatch, useSelector } from "react-redux"
import urls from "../../constants/apiurl"
import ApiCaller from "../../constants/ApiCaller"
import { showDangerToast } from "../../constants/toaster"
import Utils from "../../constants/Utils"
import { formatIndianNumber } from "../../lib/formatIndianNumber"
import UserActivityTable from "./UserActivityTable"

export const ClamView = (props) => {
    const location = useLocation();
    const { status } = location.state?.data || {};
    const LOADING_ENABLE = useSelector(state => state?.loading)
    const [clamDetails, setClamDetails] = useState([])
    const [enableApproveBtn, setEnableApproveBtn] = useState(false)
    const { formatDate } = Utils();
    const userData = useSelector(state => state?.userData)
    const [recentUserVideos, setRecentUserVideos] = useState([])
    const [userDetailsData, setUserDetailsData] = useState({})
    const router = useNavigate()
    const dispatch = useDispatch()
    const { id, userId } = useParams()
    const [pagerecord, setPagerecord] = useState({
        totalItems: 0,
        pageNumber: 1,
        pageSize: 10,
        totalPages: 1
    })

    useEffect(() => {
        console.log("977777777777777777777777777777777777777777777777777777777", status)
        console.log(id, userId)
        dispatch(updateTopHeader('Special Reward Clam Details'))
        if (userId) {
            getUserDetails()
            getClamRequestAnalyticsDetails()
        }
    }, [id])

    const handleMarkAsClam = async () => {
        let clammedUserIds = []
        for (let i = 0; i < clamDetails?.length; i++) {
            if (clamDetails[i]?.selectForApproval) {
                clammedUserIds.push(clamDetails[i]?.id)
            }
        }
        console.log(clammedUserIds)
        try {
            dispatch(uplodateLoading(true))
            let postJson = {
                clammedIds: clammedUserIds,
                requestId: id,
            }
            let path = urls.markAsClam
            let res = await ApiCaller.post(postJson, path, userData?.access_token)
            const response = await res.response.json()
            if (response.status == 200) {
                dispatch(uplodateLoading(false))
                getClamRequestAnalyticsDetails()
            } else {
                dispatch(uplodateLoading(false))
                showDangerToast(response.message)
            }
        } catch (error) {
            dispatch(uplodateLoading(false))
            console.error(error)
            showDangerToast(error.message)
        }
    }
    const handleCloseRequest = async () => {
        try {
            // alert()
            dispatch(uplodateLoading(true))
            let path = urls.closeClamRequest + "?requestId=" + id
            let res = await ApiCaller.get({}, path, userData?.access_token)
            const response = await res.response.json()
            if (response.status == 200) {
                dispatch(uplodateLoading(false))
                router("/special-reward-clam-manager")
            } else {
                dispatch(uplodateLoading(false))
                showDangerToast(response.message)
            }
        } catch (error) {
            dispatch(uplodateLoading(false))
            console.error(error)
            showDangerToast(error.message)
        }
    }


    const getClamRequestAnalyticsDetails = async () => {
        try {
            dispatch(uplodateLoading(true))
            let postJson = {
                pageNumber: pagerecord?.pageNumber - 1 || 0,
                pageSize: pagerecord.pageSize || 12,
                shortingField: "createdAt",
                asc: true,
                requestId: id,
            }
            let path = urls.clamRequestDetails
            let res = await ApiCaller.post(postJson, path, userData?.access_token)
            const response = await res.response.json()
            if (response.status == 200) {
                dispatch(uplodateLoading(false))
                setClamDetails(response?.data?.items)
                setPagerecord({
                    totalItems: response?.data?.totalItems,
                    totalPages: response?.data?.totalPages,
                    pageNumber: pagerecord?.pageNumber,
                    pageSize: 12
                })
            } else {
                dispatch(uplodateLoading(false))
                showDangerToast(response.message)
            }
        } catch (error) {
            dispatch(uplodateLoading(false))
            console.error(error)
            showDangerToast(error.message)
        }
    }


    const getUserDetails = async () => {
        try {
            dispatch(uplodateLoading(true))
            let path = urls.userDetails + '/' + userId
            let res = await ApiCaller.get({}, path, userData?.access_token)
            const response = await res.response.json()
            if (response.status == 200) {
                dispatch(uplodateLoading(false))
                console.log(response?.data)
                setUserDetailsData(response?.data)
            } else {
                dispatch(uplodateLoading(false))
                showDangerToast(response.message)
            }
        } catch (error) {
            dispatch(uplodateLoading(false))
            console.error(error)
            showDangerToast(error.message)
        }
    }
    const onLoadMore = async () => {
        try {
            dispatch(uplodateLoading(true)); // Show loading spinner
            const nextPageNumber = pagerecord.pageNumber + 1; // Increment the page number
            const postJson = {
                pageNumber: nextPageNumber - 1 || 0,
                pageSize: pagerecord.pageSize || 12,
                shortingField: "createdAt",
                asc: true,
                requestId: id,
            };
            const path = urls.clamRequestDetails;
            const res = await ApiCaller.post(postJson, path, userData?.access_token);
            const response = await res.response.json();
            if (response.status === '200') {
                dispatch(uplodateLoading(false)); // Hide loading spinner
                setClamDetails((prevDetails) => [
                    ...prevDetails,
                    ...response?.data?.items,
                ]);
                setPagerecord((prevRecord) => ({
                    ...prevRecord,
                    pageNumber: nextPageNumber,
                    totalItems: response?.data?.totalItems,
                    totalPages: response?.data?.totalPages,
                }));
            } else {
                dispatch(uplodateLoading(false)); // Hide loading spinner
                showDangerToast(response.message);
            }
        } catch (error) {
            dispatch(uplodateLoading(false)); // Hide loading spinner
            console.error(error);
            showDangerToast(error.message);
        }
    };



    return (
        <>
            <NavBar />
            <div className='main-content'>
                <NavBarTop />
                <div className='header'>
                    <div className='logo'>
                        <div className='header bg-gradient-primary pb-8 pt-5 pt-md-8'></div>
                    </div>
                </div>
                <div className='container-fluid mt--7'>
                    <div className='row'>
                        <div className='col-md-12 text-left'>
                            <a
                                onClick={() => router("/special-reward-clam-manager")}
                                className='btn btn-sm btn-primary text-white'
                            >
                                <ReplyIcon />
                                Back
                            </a>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-md-12'>
                            <div className='card'>
                                <div className='card-body'>
                                    <div className="row">
                                        <div className="col-md-10">
                                            <p className='text-uppercase text-sm'>User Details</p>
                                        </div>
                                        {status && status === 'CLOSED' ? <></> : <div className="col-md-2">
                                            <Button
                                                variant="outlined"
                                                color="error"
                                                onClick={() => handleCloseRequest()}
                                                sx={{ marginRight: 1 }}
                                            >
                                                Close Request
                                            </Button>
                                        </div>}

                                    </div>
                                    <div className='row'>
                                        <div className='col-md-2' style={{ textAlign: 'left' }}>
                                            <label
                                                htmlFor='example-text-input'
                                                className='form-control-label'
                                            >
                                                Username
                                            </label>
                                            <p>{userDetailsData?.userName}</p>
                                        </div>
                                        <div className='col-md-2' style={{ textAlign: 'left' }}>
                                            <label
                                                htmlFor='example-text-input'
                                                className='form-control-label'
                                            >
                                                USER ID
                                            </label>
                                            <p>{userDetailsData?.chatUserId}</p>
                                        </div>
                                        <div className='col-md-2' style={{ textAlign: 'left' }}>
                                            <label
                                                htmlFor='example-text-input'
                                                className='form-control-label'
                                            >
                                                Full Name
                                            </label>
                                            <p>{userDetailsData?.fullName}</p>
                                        </div>
                                        <div className='col-md-3' style={{ textAlign: 'left' }}>
                                            <label
                                                htmlFor='example-text-input'
                                                className='form-control-label'
                                            >
                                                Email
                                            </label>
                                            <p>{userDetailsData?.email}</p>
                                        </div>
                                        <div className='col-md-3' style={{ textAlign: 'left' }}>
                                            <label
                                                htmlFor='example-text-input'
                                                className='form-control-label'
                                            >
                                                Mobile
                                            </label>
                                            <p>
                                                {userDetailsData?.ext} {userDetailsData?.contactNumber}
                                            </p>
                                        </div>
                                        <div className='col-md-2' style={{ textAlign: 'left' }}>
                                            <label
                                                htmlFor='example-text-input'
                                                className='form-control-label'
                                            >
                                                Gender
                                            </label>
                                            <p>{userDetailsData?.gender}</p>
                                        </div>
                                        <div className='col-md-2' style={{ textAlign: 'left' }}>
                                            <label
                                                htmlFor='example-text-input'
                                                className='form-control-label'
                                            >
                                                Date Of Birth
                                            </label>
                                            <p>{userDetailsData?.dob}</p>
                                        </div>
                                        <div className='col-md-2' style={{ textAlign: 'left' }}>
                                            <label
                                                htmlFor='example-text-input'
                                                className='form-control-label'
                                            >
                                                Date Of Registration
                                            </label>
                                            <p>{formatDate(userDetailsData?.createdAt)}</p>
                                        </div>
                                        <div className='col-md-2' style={{ textAlign: 'left' }}>
                                            <label
                                                htmlFor='example-text-input'
                                                className='form-control-label'
                                            >
                                                Exclusive Enable
                                            </label>
                                            <p>
                                                {userDetailsData?.exclusiveEnable ? (
                                                    <span className='label label-default'>Enabled</span>
                                                ) : (
                                                    <span className='label label-default'>Disabled</span>
                                                )}
                                            </p>
                                        </div>
                                        <div className='col-md-2' style={{ textAlign: 'left' }}>
                                            <label
                                                htmlFor='example-text-input'
                                                className='form-control-label'
                                            >
                                                Account Type
                                            </label>
                                            <p>{userDetailsData?.accountType}</p>
                                        </div>
                                        <div className='col-md-2' style={{ textAlign: 'left' }}>
                                            <label
                                                htmlFor='example-text-input'
                                                className='form-control-label'
                                            >
                                                Register Via
                                            </label>
                                            <p>{userDetailsData?.signInType}</p>
                                        </div>
                                        <div className='col-md-2' style={{ textAlign: 'left' }}>
                                            <label
                                                htmlFor='example-text-input'
                                                className='form-control-label'
                                            >
                                                Total Chips:
                                            </label>
                                            <p>{formatIndianNumber(userDetailsData?.totalChipsBalance)}</p>
                                        </div>
                                        <div className='col-md-10' style={{ textAlign: 'left' }}>
                                            <label
                                                htmlFor='example-text-input'
                                                className='form-control-label'
                                            >
                                                Category:
                                            </label>
                                            <p>{userDetailsData?.userPreferredTags?.join(",")}</p>
                                        </div>
                                    </div>

                                    <hr />
                                    <div className="row">
                                        <div className="col-md-10" style={{ textAlign: 'center' }}>
                                            <h3>Invited Users Analytics</h3>
                                        </div>
                                        <div className="col-md-2">

                                            {enableApproveBtn ? <Button variant="contained" onClick={() => handleMarkAsClam()}>Mark as Claim</Button> : <></>}
                                        </div>
                                    </div>
                                    {clamDetails?.length > 0 ? <UserActivityTable
                                        rows={clamDetails}
                                        setClamDetails={setClamDetails}
                                        setEnableApproveBtn={setEnableApproveBtn}
                                        enableLoadMore={pagerecord?.totalPages === pagerecord?.pageNumber}
                                        onLoadMore={() => onLoadMore()}
                                    /> : <div className='text-center'>
                                        <img width={'25%'} src={NoDataImg}></img>
                                        <br />
                                        <label style={{ fontWeight: 'bold' }}>
                                            {LOADING_ENABLE ? <>Loading Data.....</> : <>No Pending Claims</>}
                                        </label>
                                    </div>}

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}